<div *ngIf="tableConstructorData">
  <div *ngIf="tableConstructorData.data.tbody.length === 0" class="p-3">
    <h4 class="pt-1 pb-4" data-test-id="no-items-hint">
      {{ noUsersHint | translate }}
    </h4>
  </div>
  <div *ngIf="tableConstructorData.data.tbody.length > 0">
    <table-constructor
      [tableData]="tableConstructorData.data"
      [tableCellAttributes]="tableConstructorData.cellAttributes"
      [tableCellStyles]="tableConstructorData.cellStyles"
      [customTableStyle]="'members-table'"
      (action)="onAction($event)"
      [isExpired]="isExpired"
      [redirectToLoginIfNoSession]="redirectToLoginIfNoSession"
    >
      <ng-content></ng-content>
    </table-constructor>
  </div>
</div>
<div
  *ngIf="!tableConstructorData"
  class="spinner-grow text-primary load m-5"
  role="status"
  data-test-id="loading-spinner"
>
  <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
</div>
